<app-modal-basic modalContentId="modal-configuracao-itens-nfe" [showNow]="open" (opened)="onOpened()"
  (closed)="onClosed()">
  <div class="app-modal-header">
    <h4 class="modal-title">
      <i class="modal-title"></i>
      Configuração dos Itens
    </h4>
  </div>
  <div class="app-modal-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="form-group col-sm-12">
          <app-dim-checkbox label="Código de benefício fiscal" formControlName="aplicarCbenef"></app-dim-checkbox>
          <app-combobox-cbenef-fiscais appendTo="#modal-configuracao-itens-nfe" formControlName="cBenef" label=""
            [notFoundPlusIcon]="false" [pencilIcon]="false" [customData]="{ cst: cst }"
            [disabled]="!form.get('aplicarCbenef').value"></app-combobox-cbenef-fiscais>
        </div>
        <div class="form-group col-sm-12" *ngIf="crtNormal">
          <app-dim-checkbox label="Código CST/CSOSN" formControlName="aplicarCst"></app-dim-checkbox>
          <ng-content *ngIf="form.get('aplicarCst').value" select="[slot=tip]"></ng-content>
          <ng-select appendTo="#modal-configuracao-itens-nfe" formControlName="cst" placeholder="Selecione"
            [items]="cstsListCRTNormal" bindLabel="nome" bindValue="id">
          </ng-select>
          <show-errors [control]="form.controls['cst']"></show-errors>
        </div>
        <div class="form-group col-sm-12" *ngIf="crtSimples">
          <app-dim-checkbox label="Código CST/CSOSN" formControlName="aplicarCst"></app-dim-checkbox>
          <ng-content *ngIf="form.get('aplicarCst').value" select="[slot=tip]"></ng-content>
          <ng-select appendTo="#modal-configuracao-itens-nfe" formControlName="cst" placeholder="Selecione"
            [items]="cstsListCRTSimples" bindLabel="nome" bindValue="id">
          </ng-select>
          <show-errors [control]="form.controls['cst']"></show-errors>
        </div>
        <div class="form-group col-sm-12">
          <app-dim-checkbox label="Cód. Benef. Crédito Presumido" formControlName="aplicarCCredPresumido"></app-dim-checkbox>
          <ng-select appendTo="#modal-configuracao-itens-nfe" [loading]="loading['codigosCreditoPresumido']"
            formControlName="cCredPresumido" placeholder="Selecione" [items]="codigosCreditoPresumido"
            bindLabel="descricao" bindValue="codigo">
          </ng-select>
          <show-errors [control]="form.controls['cCredPresumido']"></show-errors>
        </div>
      </div>
      <div class="row" *ngIf="notaEntradaImportacao">
        <div class="col-sm-8 form-group">
          <app-dim-checkbox label="IPI" formControlName="aplicarIPI"></app-dim-checkbox>
          <ng-select appendTo="#modal-configuracao-itens-nfe"
            formControlName="cstIPI" [items]="cstsIPI" bindLabel="descricao"
            bindValue="tipo" placeholder="Situação Tributária IPI"></ng-select>
          <show-errors [control]="form.controls.cstIPI"></show-errors>
        </div>
        <div class="col-sm-4 form-group">
          <label for="form_aliquotaIPI">Alíquota IPI</label>
          <input id="form_aliquotaIPI" type="text" formControlName="aliquotaIPI" currencyMask
            inputmode="numeric" [options]="{prefix: '', precision: 2, allowNegative: false}"
            class="form-control" placeholder="Alíquota IPI">
          <show-errors [control]="form.controls.aliquotaIPI"></show-errors>
        </div>
      </div>
      <div class="row" *ngIf="notaEntradaImportacao">
        <div class="col-sm-8 form-group">
          <app-dim-checkbox label="PIS" formControlName="aplicarPIS"></app-dim-checkbox>
          <ng-select appendTo="#modal-configuracao-itens-nfe" [items]="cstsPIS"
            bindLabel="descricao" bindValue="tipo" placeholder="Situação Tributária PIS"
            formControlName="cstPIS"></ng-select>
          <show-errors [control]="form.controls.cstPIS"></show-errors>
        </div>
        <div class="col-sm-4 form-group">
          <label for="form_aliquotaPIS">Alíquota PIS</label>
          <input id="form_aliquotaPIS" type="text" formControlName="aliquotaPIS" currencyMask
            inputmode="numeric" [options]="{prefix: '', precision: 2, allowNegative: false}"
            class="form-control" placeholder="Aliquota PIS">
          <show-errors [control]="form.controls.aliquotaPIS"></show-errors>
        </div>
      </div>
      <div class="row" *ngIf="notaEntradaImportacao">
        <div class="col-sm-8 form-group">
          <app-dim-checkbox label="COFINS" formControlName="aplicarCOFINS"></app-dim-checkbox>
          <ng-select id="form_cstCOFINS" appendTo="#modal-configuracao-itens-nfe" [items]="cstsCOFINS"
            bindLabel="descricao" bindValue="tipo" placeholder="Situação Tributária COFINS"
            formControlName="cstCOFINS"></ng-select>
          <show-errors [control]="form.controls.cstCOFINS"></show-errors>
        </div>
        <div class="col-sm-4 form-group">
          <label for="form_aliquotaCOFINS">Alíquota COFINS</label>
          <input id="form_aliquotaCOFINS" type="text" formControlName="aliquotaCOFINS" currencyMask
            inputmode="numeric" [options]="{prefix: '', precision: 2, allowNegative: false}"
            class="form-control" placeholder="Alíquota COFINS">
          <show-errors [control]="form.controls.aliquotaCOFINS"></show-errors>
        </div>
      </div>
      <div class="row" *ngIf="permiteImpostosRtc">
        <div class="col-sm-12 form-group">
          <app-dim-checkbox label="IBS/CBS" formControlName="aplicarIBSCBS"></app-dim-checkbox>
          <ng-select id="form_cstIBSCBS" appendTo="#modal-configuracao-itens-nfe" [items]="cstsIBSCBS"
            bindLabel="descricao" bindValue="cst" placeholder="CST IBS/CBS" formControlName="cstIBSCBS"
             [searchFn]="buscaCstIBSCBS">
            <ng-template ng-label-tmp ng-option-tmp let-item="item">
              {{ item.cst }} - {{ item.descricao }}
            </ng-template>
          </ng-select>
          <show-errors [control]="form.controls.cstIBSCBS"></show-errors>
        </div>
        <div class="col-sm-12 form-group">
          <ng-select id="form_cClassTribIBSCBS" appendTo="#modal-configuracao-itens-nfe" [items]="cClassTribIBSCBS"
            bindLabel="descricao" bindValue="cClassTrib" placeholder="Código de Classificação Tributária IBS/CBS"
            formControlName="cClassTribIBSCBS" [searchFn]="buscaCClassTribIBSCBS">
            <ng-template ng-label-tmp ng-option-tmp let-item="item">
              {{ item.cClassTrib }} - {{ item.nome }}
            </ng-template>
          </ng-select>
          <show-errors [control]="form.controls.cClassTribIBSCBS"></show-errors>
        </div>
        <div class="col-sm-12 form-group" *ngIf="['510', '515'].includes(form.get('cstIBSCBS').value)">
          <label for="form_percDiferimentoIBSCBS">% Diferimento</label>
          <input id="form_percDiferimentoIBSCBS" type="text" formControlName="percDiferimentoIBSCBS" currencyMask
            inputmode="numeric" [options]="{prefix: '', precision: 2, allowNegative: false, max: 100.0}"
            class="form-control" placeholder="% Diferimento">
          <show-errors [control]="form.controls.percDiferimentoIBSCBS"></show-errors>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <button type="submit" class="btn btn-primary">
            <app-loading icone="ti-save" textoLoading="Aplicando" texto="Aplicar"></app-loading>
          </button>
          <button type="button" class="btn btn-danger" (click)="onCancel()">
            <app-loading icone="ti-close" textoLoading="Cancelar" texto="Cancelar"></app-loading>
          </button>
        </div>
      </div>
    </form>
  </div>
  <div class="app-modal-footer"></div>
</app-modal-basic>